import { createUseStyles } from 'react-jss';
import ReactSlider from 'react-slider';

import styles from './styles';
import Track from './Track';
import { SliderProps } from './types';

const useStyles = createUseStyles(styles);

const Slider = (sliderProps: SliderProps) => {
  const classes = useStyles();

  return (
    <ReactSlider
      className={classes.slider}
      thumbClassName={classes.thumb}
      renderTrack={(props, state) => <Track {...props} index={state.index} />}
      {...sliderProps}
    />
  );
};

export default Slider;
